@if (formGroup) {
  <app-select-input
    [controlName]="controlName"
    [controlLabel]="controlLabel"
    [formGroup]="formGroup"
    [options]="accounts"
    optionValueKey="accountName"
    [multiple]="multiple"
    [showAllOption]="showAllOption"
    [showNoneOption]="showNoneOption"
    (selectionChange)="onSelectionChanged($event)"
    (openedChange)="onOpenedChanged($event)">
  </app-select-input>
}

@if (!formGroup) {
  <app-select-input
    [controlName]="controlName"
    [controlLabel]="controlLabel"
    [(model)]="model"
    [options]="accounts"
    optionValueKey="accountName"
    [multiple]="multiple"
    [showAllOption]="showAllOption"
    [showNoneOption]="showNoneOption"
    (selectionChange)="onSelectionChanged($event)"
    (openedChange)="onOpenedChanged($event)">
  </app-select-input>
}
